import mainTokenIcon from 'modules/common/icons/main-token-icon.svg';
import stakeTokenIcon from 'modules/common/icons/stake-token-icon.svg';
import { IDeFiItem, ProtocolType } from 'modules/defi/types';

export const DEFIES_MOCK: IDeFiItem[] = [
  {
    tokens: [
      {
        icon: stakeTokenIcon,
        name: 'Token 1',
      },
      {
        icon: mainTokenIcon,
        name: 'Token 2',
      },
    ],
    protocol: 'Curve Finance',
    protocolIcon: stakeTokenIcon,
    protocolType: ProtocolType.Farming,
    network: 'Network 1',
    networkIcon: mainTokenIcon,
    link: 'https://example.com',
  },
  {
    tokens: [
      {
        icon: stakeTokenIcon,
        name: 'Token 3',
      },
      {
        icon: mainTokenIcon,
        name: 'Token 4',
      },
    ],
    protocol: 'Curve Finance',
    protocolIcon: stakeTokenIcon,
    protocolType: ProtocolType.Farming,
    network: 'Network 2',
    networkIcon: mainTokenIcon,
    link: 'https://example.com',
  },
];
